import React from 'react';
import { Helmet } from 'react-helmet';

import { Container, Wrapper, Title } from './styles';

/**
 * Every route renders this page: the v4 sales page no longer sells (DEV-1062).
 *
 * It is deliberately reachable from *any* path, including the plan and success
 * URLs. Those links were published in bios, ads and WhatsApp messages that we
 * cannot edit, so a student following one still arrives here — and gets an
 * explanation rather than a checkout form that would fail, or a 404 that reads
 * like the coach's page is gone.
 */
export default function Discontinued() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="robots" content="noindex" />
        <title>Página de vendas desativada</title>
      </Helmet>
      <Container>
        <Wrapper>
          <Title>Esta página saiu do ar</Title>
          <p>
            Esta página de vendas foi desativada e não recebe mais novas
            assinaturas.
          </p>
          <p>
            Se você quer assinar um plano, fale com seu personal e peça o link
            novo de pagamento.
          </p>
          <p>
            Já é assinante? Sua assinatura continua ativa normalmente, nada muda
            para você.
          </p>
        </Wrapper>
      </Container>
    </>
  );
}
